interface PiecesItem {
  label: string;
  href: string;
}

interface Props {
  title: string;
  description: string;
  items: PiecesItem[];
  highlight: string;
  imageAlt: string;
  imageSrc?: string;
}

export default function PiecesSection({
  title,
  description,
  items,
  highlight,
  imageAlt,
  imageSrc,
}: Props) {
  return (
    <section className="w-full bg-white py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Image left */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden border-2 border-dashed border-[#FF6B4A]/40 bg-[#EEF2F4] aspect-[4/3]">
              <img
                src={imageSrc || "https://storage.readdy-site.link/project_files/8c50c74a-580c-4bdf-a3bb-6fdfe51fdb55/697ebe72-c6d8-4373-a2d0-e385e88779b2_changement-paumelle-fenetre-1024x683-1.jpg?v=7d21e30618ff90878900ba8be7cb1a40"}
                alt={imageAlt}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Text right */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block text-[#FF6B4A] text-xs font-bold tracking-widest uppercase mb-3">
              LES PIÈCES QUE NOUS REMPLAÇONS
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1E3A47] mb-4 leading-tight">
              {title}
            </h2>
            <p className="text-[#243038] leading-relaxed mb-6">
              {description}
            </p>
            <ul className="space-y-3 mb-6">
              {items.map((item, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-[#1E3A47] flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-white text-xs" />
                  </span>
                  <Link
                    to={item.href}
                    className="text-[#243038] hover:text-[#FF6B4A] transition-colors underline underline-offset-2 decoration-[#FF6B4A]/30 hover:decoration-[#FF6B4A]"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="text-[#1E3A47] text-sm font-semibold flex items-center gap-2">
              <i className="ri-check-double-line text-[#FF6B4A]" />
              {highlight}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}